import { useCallback } from 'react'
import { CoreUnderivedEventData } from '../core'
import { Event } from '../eventsV2'
import { TealiumUnderivedEventData } from '../tealium'
import { useDerivedCoreEventData } from './useDerivedCoreEventData'
import { useDerivedTealiumEventData } from './useDerivedTealiumEventData'

export type UseEventConfigGeneric<CoreData, TealiumData> = {
  core?: CoreData & {
    additionalData?: Record<string, unknown>
  }
  tealium?: TealiumData & {
    additionalData?: Record<string, unknown>
  }
}
export type UseEventConfig = UseEventConfigGeneric<CoreUnderivedEventData, TealiumUnderivedEventData>

/**
 * Takes a configuration of underived event data fields and additional data, and returns
 * a built event based off of the configuration
 *
 * @param options
 * @returns a createEvent factory that creates an event with all derived fields included
 */
export const useEvent = (options: UseEventConfig) => {
  const derivedCoreEventData = useDerivedCoreEventData()
  const derivedTealiumEventData = useDerivedTealiumEventData()

  const createEvent = useCallback(
    () => {
      const event: Event = {}
      if (options.core) {
        event.core = {
          ...derivedCoreEventData,
          ...options.core
        }
      }
      if (options.tealium) {
        event.tealium = {
          ...derivedTealiumEventData,
          ...options.tealium
        }
      }
      return event
    },
    [derivedCoreEventData, derivedTealiumEventData, options]
  )

  return createEvent
}
